import resetNewPasswordSendReducer from 'src/app/redux/reducers/reset/resetNewPasswordSendReducer';
import resetEmailReducer from 'src/app/redux/reducers/reset/resetEmailReducer';
import resetNewPasswordReducer from 'src/app/redux/reducers/reset/resetNewPasswordReducer';
import resetEmailSendReducer from 'src/app/redux/reducers/reset/resetEmailSendReducer';


export default {
  resetEmailReducer,
  resetEmailSendReducer,
  resetNewPasswordReducer,
  resetNewPasswordSendReducer
};
